import { QueryClient } from "@tanstack/react-query";

// Export queryClient so it can be used to invalidate queries externally
export const enduserQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Invalidate all enduser queries and refetch data.
 * Useful for refreshing data in the portal preview.
 */
export function invalidateEnduserQueries() {
  return enduserQueryClient.invalidateQueries();
}

/**
 * Invalidate form response queries to refetch after form submission.
 */
export function invalidateFormResponseQueries() {
  return enduserQueryClient.invalidateQueries({ queryKey: ["form_responses"] });
}

/**
 * Invalidate calendar event queries to refetch after booking an appointment.
 */
export function invalidateCalendarEventQueries() {
  return enduserQueryClient.invalidateQueries({ queryKey: ["calendar_events"] });
}
